<template>
    <modal
        :active="active"
        :large="true"
        :title="title()"
        @closed="$emit('closed', true)"
    >
        <div class="columns is-tablet">
            <form-field
                :error="error.manufacturer_price_type_id"
                class="column"
                inner-container-class="select is-fullwidth"
                label="Pristype"
            >
                <input-select
                    v-model="form.manufacturer_price_type_id"
                    :error="error.manufacturer_price_type_id"
                    :options="filteredPriceTypes"
                    option-title-prop="name"
                    option-value-prop="id"
                />
            </form-field>
            <form-field
                :error="error.price"
                class="column"
                label="Pris"
            >
                <InputText v-model="form.price" type="number"/>
            </form-field>
        </div>

        <div class="columns is-tablet" v-if="item.type.key === 'no_serial'">
            <form-field class="column">
                <InputCheckbox v-model="form.out_of_stock_sales" label="Salgbar når lager er tomt" :inline="true" :true-value="true" :false-value="false"/>
            </form-field>
        </div>
        <p v-if="selectedPriceType && selectedPriceType.require_return_item">
            Den valgte pristype kræver returvare.
        </p>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-default" @click="$emit('closed', true)">Annuller</button>
                    <button class="button is-primary" @click="create">{{ saveButtonText }}</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputSelect, InputText, InputCheckbox} from '@elems/form'

export default {
    components: {
        Modal,
        FormField,
        InputSelect,
        InputText,
        InputCheckbox,
    },
    props: {
        active: Boolean,
        item: Object,
    },
    data() {
        return {
            form: {
                manufacturer_price_type_id: null,
                price: '',
                out_of_stock_sales: false,
            },
            error: [],
        }
    },
    computed: {
        selectedPriceType() {
            return this.item.manufacturer?.priceTypes.find(priceType => {
                return priceType.id === this.form.manufacturer_price_type_id;
            });
        },
        filteredPriceTypes() {
            return this.item.manufacturer?.priceTypes.filter(priceType => {
                return !this.itemPriceTypesIds.includes(priceType.id);
            });
        },
        itemPriceTypesIds() {
            return this.item.prices.map(price => price.manufacturer_price_type_id);
        },
        saveButtonText() {
            return 'Tilknyt pris'
        },
        apiUrl() {
            return `/api/items/${this.item.id}/prices`;
        }
    },
    methods: {
        title() {
            return 'Tilknyt pristype og pris'
        },
        resetForm() {
            this.form.manufacturer_price_type_id = null;
            this.form.price = '';
            this.form.out_of_stock_sales = false;
        },
        create() {
            window.axios.post(this.apiUrl, this.form)
                .then(({ data }) => {
                    this.$emit('closed')
                    this.$emit('created', data)
                    this.$store.dispatch('setSuccess', 'Prisen er oprettet');
                    this.resetForm();
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.error = error.response.data.errors
                    }
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
.footer-spacer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
}

.customer-details {
    h4 {
        align-items: center;
        border-bottom: 1px solid #bbb;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }
}

.column {
    padding: 0 0.75rem;
}
</style>
